<contact-grid
    #contactgrid
    *ngIf="this.selectedSupplierCode"
    source="manage-contact"
    (changeSubmitted)="submitChanges($event)"
></contact-grid>
